import {useCallback, useContext, useEffect, useState} from 'react';
import {fabric} from 'fabric';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';

export const useImageSize = () => {
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const [scaleValue, setScaleValue] = useState(1);

  const getActiveImage = useCallback(() => {
    if (Array.isArray(activeObjects) && activeObjects.length > 0) {
      return activeObjects[0];
    }
    return null;
  }, [activeObjects]);

  const getScaleValue = useCallback(() => {
    const uyoImg = getActiveImage();
    if (!uyoImg || !uyoImg._originalObject) return 1;

    const originalScale = fabric.util.findScaleToCover(uyoImg, uyoImg._originalObject);
    return (uyoImg.scaleX / originalScale).toFixed(1);
  }, [getActiveImage]);

  const setImageScale = useCallback(
    (newValue) => {
      const uyoImage = getActiveImage();
      if (!uyoImage || !canvas) return;

      setScaleValue(newValue);

      const scale = fabric.util.findScaleToCover(uyoImage, uyoImage._originalObject);
      const newScale = scale * Number(newValue);

      uyoImage.scale(newScale);
      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [canvas, getActiveImage]
  );

  useEffect(() => {
    if (!canvas) return undefined;

    const resetHandler = () => {
      setScaleValue(1);
    };

    const scaleHandler = () => {
      const scale = getScaleValue();
      setScaleValue(scale);
    };

    canvas.on('object:modified', scaleHandler);
    canvas.on('object:reseted:uyo', resetHandler);

    return () => {
      canvas.off('object:reseted:uyo', resetHandler);
      canvas.off('object:modified', scaleHandler);
    };
  }, [canvas, getScaleValue]);

  useEffect(() => {
    const scale = getScaleValue();
    setScaleValue(scale);
  }, [activeObjects, getScaleValue]);

  return {
    scaleValue,
    setImageScale,
  };
};
